import { reactive, toRefs } from "vue";
import { canTrackRoute, trackRoute } from "./api.js";
import { merge } from "lodash-es";
const state = reactive({
  template: null,
  skipSamePath: true,
  pendingRecord: null,
  trackRoute,
  canTrackRoute
});
const useState = () => toRefs(state);
const setState = (params) => {
  merge(state, params);
};
export {
  state as default,
  setState,
  useState
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdGUuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9wbHVnaW5zL3RyYWNrZXIvc3RhdGUuanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgcmVhY3RpdmUsIHRvUmVmcyB9IGZyb20gXCJ2dWVcIjtcbmltcG9ydCB7IHRyYWNrUm91dGUsIGNhblRyYWNrUm91dGUgfSBmcm9tIFwiLi9hcGlcIjtcbmltcG9ydCB7IG1lcmdlIH0gZnJvbSBcImxvZGFzaC1lc1wiO1xuXG5jb25zdCBzdGF0ZSA9IHJlYWN0aXZlKHtcbiAgdGVtcGxhdGU6IG51bGwsXG4gIHNraXBTYW1lUGF0aDogdHJ1ZSxcbiAgcGVuZGluZ1JlY29yZDogbnVsbCxcbiAgdHJhY2tSb3V0ZSxcbiAgY2FuVHJhY2tSb3V0ZSxcbn0pO1xuXG5leHBvcnQgY29uc3QgdXNlU3RhdGUgPSAoKSA9PiB0b1JlZnMoc3RhdGUpO1xuXG5leHBvcnQgY29uc3Qgc2V0U3RhdGUgPSAocGFyYW1zKSA9PiB7XG4gIG1lcmdlKHN0YXRlLCBwYXJhbXMpO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgc3RhdGU7XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBSUssTUFBQyxRQUFRLFNBQVM7QUFBQSxFQUNyQixVQUFVO0FBQUEsRUFDVixjQUFjO0FBQUEsRUFDZCxlQUFlO0FBQUEsRUFDZjtBQUFBLEVBQ0E7QUFDRixDQUFDO0FBRVcsTUFBQyxXQUFXLE1BQU0sT0FBTyxLQUFLO0FBRTlCLE1BQUMsV0FBVyxDQUFDLFdBQVc7QUFDbEMsUUFBTSxPQUFPLE1BQU07QUFDckI7In0=
